import React from 'react';
import './FooterBrand.css';

export function FooterBrand() {
  return (
    <div className="footer-brand">
      <div className="footer-brand__company">
        <img
          src="/images/aimers_logo.jpg"
          alt="AIMERS Logo"
          className="footer-brand__logo"
        />
        <span className="footer-brand__name">AIMERS</span>
      </div>
      <p className="footer-brand__copyright">
        Copyright 2026. AIMERS Co. all rights reserved.
      </p>
    </div>
  );
}
